import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const starRatingFn = /* @__PURE__ */ createRecipe('star-rating', {}, [])

const starRatingVariantMap = {}

const starRatingVariantKeys = Object.keys(starRatingVariantMap)

export const starRating = /* @__PURE__ */ Object.assign(memo(starRatingFn.recipeFn), {
  __recipe__: true,
  __name__: 'starRating',
  __getCompoundVariantCss__: starRatingFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: starRatingVariantKeys,
  variantMap: starRatingVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, starRatingVariantKeys)
  },
  getVariantProps: starRatingFn.getVariantProps,
})